import { render, staticRenderFns } from "./MessageAlert.vue?vue&type=template&id=45d43bb6&scoped=true&"
import script from "./MessageAlert.vue?vue&type=script&lang=ts&"
export * from "./MessageAlert.vue?vue&type=script&lang=ts&"
import style0 from "./MessageAlert.vue?vue&type=style&index=0&id=45d43bb6&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d43bb6",
  null
  
)

export default component.exports